import { Box, Grid, Typography } from '@mui/material'
import GroupsIcon from '@mui/icons-material/Groups'
import StarIcon from '@mui/icons-material/Star'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import HistoryIcon from '@mui/icons-material/History'
import { colors } from 'constants/colors'
import React from 'react'
import { useTheme } from '@mui/material'
import LoginCard from 'components/structure/LoginCard'
import FeatureCard from 'components/structure/FeatureCard'

const FEATURES = [
  {
    icon: <GroupsIcon />,
    title: 'Up to 50 Managers',
    description: 'Works with leagues of up to 50 managers. Larger leagues show insights for the current top 50 in standings.',
  },
  {
    icon: <StarIcon />,
    title: 'GW Splits',
    description: 'See counts and percentages of captaincy and chips played, with the ability to export the data to share with your friends.',
  },
  {
    icon: <SwapHorizIcon />,
    title: 'GW Transfers Analytics',
    description: 'Get various details and insights about the transfers made by your mini-league members.',
  },
  {
    icon: <HistoryIcon />,
    title: 'History Insights',
    description: 'Get insights for every gameweek of your mini-league this season.',
  },
]

const SignInSide: React.FC = () => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 5 },
        gap: { xs: 4, sm: 5 },
      }}
    >
      {/* Hero title */}
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          component='h1'
          fontFamily='PremierLeagueHeavy'
          sx={{
            fontSize: { xs: '1.9rem', sm: '2.6rem' },
            lineHeight: 1.1,
            color: isDark ? colors.MOONSTONE : colors.ALMOST_BLACK,
            mb: 0.75,
          }}
        >
          FPL Mini-League{' '}
          <Box component='span' sx={{ color: colors.WHITE }}>
            Insights
          </Box>
        </Typography>
        <Typography
          fontFamily='PremierLeagueBold'
          sx={{ fontSize: { xs: '0.9rem', sm: '1rem' }, color: isDark ? colors.MOONSTONE : colors.ALMOST_BLACK, }}
        >
          Get your FPL mini-leagues gameweek insights easily
        </Typography>
      </Box>

      {/* Main row */}
      <Grid container spacing={2.5} sx={{ maxWidth: 1200, width: '100%' }} alignItems='stretch'>

        {/* Login card — display:flex so Paper fills full item height */}
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <LoginCard />
        </Grid>

        {/* Feature cards 2×2 — display:flex passes height to inner grid */}
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <Grid container spacing={2} sx={{ flex: 1, alignContent: 'stretch' }}>
            {FEATURES.map(f => (
              <Grid item xs={6} key={f.title} sx={{ display: 'flex' }}>
                <FeatureCard icon={f.icon} title={f.title} description={f.description} />
              </Grid>
            ))}
          </Grid>
        </Grid>

      </Grid>
    </Box>
  )
}

export default SignInSide
